import React from 'react';
interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  children: React.ReactNode;
}
export function Table({
  children,
  className = '',
  ...props
}: TableProps) {
  return <div className="w-full overflow-x-auto rounded-xl border border-slate-200 shadow-sm bg-white" data-id="element-153">
      <table className={`w-full text-left text-sm ${className}`} {...props} data-id="element-154">
        {children}
      </table>
    </div>;
}
export function TableHeader({
  children
}: {
  children: React.ReactNode;
}) {
  return <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-155">
      {children}
    </thead>;
}
export function TableBody({
  children
}: {
  children: React.ReactNode;
}) {
  return <tbody className="divide-y divide-slate-100" data-id="element-156">{children}</tbody>;
}
export function TableRow({
  children,
  className = '',
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return <tr className={`hover:bg-slate-50 transition-colors ${onClick ? 'cursor-pointer' : ''} ${className}`} onClick={onClick} data-id="element-157">
      {children}
    </tr>;
}
export function TableHead({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <th className={`px-6 py-4 font-semibold whitespace-nowrap ${className}`} data-id="element-158">
      {children}
    </th>;
}
export function TableCell({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <td className={`px-6 py-4 text-slate-700 ${className}`} data-id="element-159">{children}</td>;
}